export function getSizeScaledFromFullHD(size: number) {
  return size * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function getStyleVariable(name: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
}